/* TRU: Convermax product cards. Products with more than one variant get a "See options" button,
   an "Options available" note (e.g. "4 sizes") and no SKU, since the card stands for the whole product.
   Single-variant products keep their SKU and "View item". Variant counts and each variant's stock note
   come from a tiny product template (templates/product.tru-vcount.liquid) and are cached for the session. */
(function () {
  var mem = {};
  var KEY = 'tru-vc2'; /* v2 adds per-variant stock notes; v1 entries are ignored */
  try { mem = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) {}
  try { sessionStorage.removeItem('tru-vc1'); } catch (e) {}
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(mem)); } catch (e) {} }
  var inflight = {};
  function info(handle) {
    if (mem[handle]) return Promise.resolve(mem[handle]);
    if (inflight[handle]) return inflight[handle];
    inflight[handle] = fetch('/products/' + handle + '?view=tru-vcount', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        var d = null; try { d = JSON.parse(t); } catch (e) {}
        if (d) { mem[handle] = d; save(); }
        return d;
      }).catch(function () { return null; });
    return inflight[handle];
  }
  function label(d) {
    return d.n + ' options available';
  }
  /* One stock line for the card: the shared note when every option has the same one,
     "Stock varies by option" only when they really differ, nothing when no option has a note. */
  function stockText(d) {
    if (!d.notes || !d.notes.length) return 'Stock varies by option';
    var notes = d.notes.map(function (s) { return String(s || '').replace(/\s+/g, ' ').trim(); });
    var first = notes[0].toLowerCase();
    var same = notes.every(function (s) { return s.toLowerCase() === first; });
    return same ? notes[0] : 'Stock varies by option';
  }
  function apply(card) {
    if (card.getAttribute('data-tru-vc')) return;
    card.setAttribute('data-tru-vc', '1');
    var a = card.querySelector('a.cm_product-item__title, a.cm_product-item__image-container');
    if (!a) return;
    var m = a.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    info(m[1]).then(function (d) {
      if (!d) return;
      if (d.n > 1) {
        card.classList.add('tru-card--multi');
        var sku = card.querySelector('.cm_product-item__sku-container');
        if (sku) {
          sku.hidden = true;
          var note = document.createElement('p');
          note.className = 'tru-card__opts';
          note.textContent = label(d);
          sku.parentNode.insertBefore(note, sku.nextSibling);
        }
        var price = card.querySelector('.cm_product-item__price');
        if (price && !/from/i.test(price.textContent)) price.insertAdjacentHTML('afterbegin', '<span class="tru-card__from">From </span>');
        card.querySelectorAll('.cm_product-item__buttons .cm_button').forEach(function (b) { b.textContent = 'See options'; });
        var stock = stockText(d);
        if (stock && !card.querySelector('.tru-card__stock')) {
          var st = document.createElement('p');
          st.className = 'tru-card__stock';
          st.textContent = stock;
          var btns = card.querySelector('.cm_product-item__buttons');
          if (btns) btns.parentNode.insertBefore(st, btns.nextSibling); else card.appendChild(st);
        }
      } else {
        card.classList.add('tru-card--single');
      }
    });
  }
  function scan() { document.querySelectorAll('.cm_product-item').forEach(apply); }
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
